<template>
  <div id="markets-warning" class="mt-4">
    <template v-if="someMarketErrored">
      <v-expansion-panels accordion class="my-3">
        <v-expansion-panel>
          <v-expansion-panel-header color="superSoftBackgroundRed">
            <span class="markets-warning-errored">
              <v-icon class="mr-2 mb-1">mdi-alert</v-icon>
              {{ $t(`views.common.marketsWarning.errored.title`) }}
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content color="superSoftBackgroundRed">
            <ul>
              <li>
                {{ $t(`views.common.marketsWarning.errored.li1`) }}
              </li>
              <li>
                {{ $t(`views.common.marketsWarning.errored.li2`) }}
              </li>
              <li>
                {{ $t(`views.common.marketsWarning.errored.li3`) }}
              </li>
              <li>
                {{ $t(`views.common.marketsWarning.errored.li32`) }}
              </li>
            </ul>
            <div class="mt-1">
              {{ $t(`views.common.marketsWarning.errored.li4`) }}
              <a href="https://www.filios.app/contacta" target="_blank">
                {{ $t(`views.common.marketsWarning.errored.li5`) }}
              </a>
            </div>
            <div class="mt-1">
              {{ $t(`views.common.marketsWarning.errored.li6`) }}
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
    <v-alert
      v-if="!someMarketErrored && someMarketPending"
      color="softWarning"
      class="px-4 py-3"
      :class="{ 'white--text': $vuetify.theme.dark }"
    >
      <v-icon :color="$vuetify.theme.dark ? 'white' : ''" class="mr-2 mb-1">
        mdi-progress-download
      </v-icon>
      {{ $t(`views.common.marketsWarning.pending.title`) }}
    </v-alert>
  </div>
</template>

<script>
import { get } from 'lodash'
import { round } from '@/lib/utils/math'
import { positionNotMarketPrice } from '@/lib/positions/positions'

export default {
  props: {
    positionSummaryDetail: {
      type: Object,
      default: null,
    },
    positions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    someMarketErrored() {
      if (this.positionSummaryDetail) return this.positionSummaryDetail.someMarketErrored

      return this.positions.some((position) => {
        if (positionNotMarketPrice(position)) return false
        return (
          round(position.positionNumber, 5) !== 0 &&
          get(position, 'market.eod.status', null) === 'errored'
        )
      })
    },
    someMarketPending() {
      if (this.positionSummaryDetail) return this.positionSummaryDetail.someMarketPending

      return this.positions.some((position) => {
        if (positionNotMarketPrice(position)) return false
        return (
          round(position.positionNumber, 5) !== 0 &&
          get(position, 'market.eod.status', null) === 'pending'
        )
      })
    },
  },
}
</script>

<style lang="scss">
#markets-warning {
  .markets-warning-errored {
    font-weight: 500;
  }
  .v-expansion-panel::before {
    box-shadow: none;
  }
}
</style>
